import React, { isValidElement, cloneElement } from 'react';
import './typelockup.stylesheet_w6m1ys.css';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { cx } from 'linaria';
import './common.stylesheet_gwz5j5.css';
import './body.stylesheet_1ravnv2.css';
import './heading.stylesheet_dmat0e.css';

const Typography = _ref => {
  let {
    component = 'p',
    children,
    className,
    depth = 0
  } = _ref;
  const typographyComponent = depth > 0 && depth < 7 ? `h${depth}` : component;
  return /*#__PURE__*/React.createElement(typographyComponent, {
    className
  }, children);
};
Typography.displayName = 'Typography';
var Typography$1 = Typography;

const bodyFonts = "b1hlewnv";
const headingFonts = "hyeg917";
const commonStyles = "c15dkkf4";

// These classnames map to what used to be in @ux/typesize
const classNames$2 = {
  smallprint: cx(bodyFonts, "sa845pk"),
  footnote: cx(bodyFonts, "f2f282k"),
  content: cx(bodyFonts, "cem567h"),
  headingXxs: cx(headingFonts, "hislugb"),
  headingXs: cx(headingFonts, "hhbfokw"),
  headingS: cx(headingFonts, "hxtvnyu"),
  headingM: cx(headingFonts, "h1ih930h"),
  headingL: cx(headingFonts, "hi001un"),
  headingXl: cx(headingFonts, "hg7604z"),
  headingXxl: cx(headingFonts, "hxexono"),
  display: cx(headingFonts, "d1rx4adl")
};

const asSubheading = "a15takya";

const makeBodyComponents = (name, displayName) => {
  const BodyComponent = _ref => {
    let {
      className,
      inTypelockup,
      ...rest
    } = _ref;
    return /*#__PURE__*/jsx(Typography$1, {
      ...rest,
      className: cx(commonStyles, classNames$2[name], inTypelockup && asSubheading, className)
    });
  };
  BodyComponent.displayName = displayName;
  return BodyComponent;
};
const BodyCopy = makeBodyComponents('content', 'BodyCopy');
const Footnote = makeBodyComponents('footnote', 'Footnote');
const Smallprint = makeBodyComponents('smallprint', 'Smallprint');

const classNames$1 = {
  asSubheading: "a165508j",
  heading01: cx(commonStyles, headingFonts, "h1s3er2h"),
  heading02: cx(commonStyles, headingFonts, "hvwd6t0"),
  heading03: cx(commonStyles, headingFonts, "h238qon"),
  heading04: cx(commonStyles, headingFonts, "hb3jnos"),
  heading05: cx(commonStyles, headingFonts, "h1xablc9"),
  heading06: cx(commonStyles, headingFonts, "hrj8fnz")
};

const makeHeading = (name, displayName) => {
  const Heading = _ref => {
    let {
      className,
      inTypelockup,
      ...rest
    } = _ref;
    return /*#__PURE__*/jsx(Typography$1, {
      className: cx(commonStyles, classNames$1[name], inTypelockup && classNames$1.asSubheading, className),
      ...rest
    });
  };
  Heading.displayName = displayName;
  return Heading;
};
const Heading01 = makeHeading('heading01', 'Heading01');
const Heading02 = makeHeading('heading02', 'Heading02');
const Heading03 = makeHeading('heading03', 'Heading03');
const Heading04 = makeHeading('heading04', 'Heading04');
const Heading05 = makeHeading('heading05', 'Heading05');
const Heading06 = makeHeading('heading06', 'Heading06');

const classNames = {
  eyebrow: "eu8ss6q"
};

const renderHeading = component => {
  return component != null && component !== false;
};
const Typelockup = _ref => {
  let {
    eyebrow,
    heading,
    subheading
  } = _ref;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [renderHeading(eyebrow) && /*#__PURE__*/jsx("div", {
      className: classNames.eyebrow,
      children: eyebrow
    }), heading, renderHeading(subheading) && /*#__PURE__*/isValidElement(subheading) && /*#__PURE__*/cloneElement(subheading, {
      inTypelockup: true
    })]
  });
};
Typelockup.displayName = 'Typelockup';
var Typelockup$1 = Typelockup;

export { BodyCopy, Footnote, Heading01, Heading02, Heading03, Heading04, Heading05, Heading06, Smallprint, Typelockup$1 as Typelockup, classNames$2 as classNames };
